import React from 'react';
import { FormattedMessage } from 'react-intl';
import { commonNameAttributes, identifiableName } from '@/utils/resultsHelper';

const ToastMessage = ({
  additionalValues = {},
  identifiers = commonNameAttributes,
  items,
  multiple,
  single,
}) => (
  <FormattedMessage
    id={items.length === 1 ? single : multiple}
    values={{ ...additionalValues, count: items.length - 1, name: identifiableName(items, identifiers) }}
  />
);

export default ToastMessage;
